import styled from 'styled-components';

export const EmptyMessage = styled.div`
  max-width: 510px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const EmptyHeader = styled.h3`
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  ${({ theme }) => theme.fonts.PoppinsText};
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 12px;
`;

export const EmptyBody = styled.span`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  line-height: 24px;
  margin-bottom: 24px;
`;

export const EmptyViewWrapper = styled.div`
  height: calc(70vh);
`;
